import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { PDFExport, savePDF } from "@progress/kendo-react-pdf";

import ShoulderElement from '../../mskchartcomponent/shoulderchart';
import LatmuscleElement from '../../mskchartcomponent/latmusclechart';
import SpineElement from '../../mskchartcomponent/spinechart';
import HiprightElement from '../../mskchartcomponent/hiprightchart';
import HipleftElement from '../../mskchartcomponent/hipleftchart';
import HamstringrightElement from '../../mskchartcomponent/hamstringrightchart';
import GulterightElement from '../../mskchartcomponent/gulterightchart';
import BalanceElement from '../../mskchartcomponent/balancechart';
import PostureElement from '../../mskchartcomponent/posture';

import PageTemplate from "Routes/pdfTemplate";

import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import './pdfstyles.css';
import {  
  mskVisualisationDetails,
  creatmskVisualisation
} from 'Actions';

class createvisual extends Component {
  static propTypes = {
    classes: PropTypes.object,
  };

  constructor(props) {
      
        super(props);
        this.state = {   
            student:this.props.data.student,
            selyear:this.props.data.selyear,
            selassessment:this.props.data.selassessment,
            visualid:this.props.data.visualid,
            previousLength:0,
            valuelength:0,
        };
       this.selectorRef = React.createRef(null);
  }

    exportPDFWithMethod = () => {
       
        this.selectorRef.current.save();
    }

    addHandleSubmit(event){
        event.preventDefault();
         let commayear = ""; 
         let commaassement = ""; 
         let {student, selyear, selassessment, visualid} = this.state;
         if(visualid==""){
            let totsel=selyear.length;
            let asstot=selassessment.length;
            event.preventDefault();
            commayear = selyear.map(item => item).join(', ');  
                   
            if(asstot!=0){
                commaassement = selassessment.map(item => item).join(', ');  
            }
        }else{
            commayear="";
            commaassement="";
        }
        this.props.creatmskVisualisation(event, student, commayear, commaassement, visualid);
        
    }

    handleInput(event) {
        const bullet = "\u2022";
        const inputValue = event.target.value;
        const cursorPosition = event.target.selectionStart;
        let lines = inputValue.split('\n');
      
        for (let i = 0; i < lines.length; i++) {
          const line = lines[i];
          if (!line.trim().startsWith(bullet)) {
            lines[i] = `${bullet} ${line.trimLeft()}`;
          }
        }
      
        let newValue = lines.join('\n');
        if (event.nativeEvent.inputType === 'deleteContentBackward') {
          if (cursorPosition === 0) {
            const lineIndex = newValue.substr(0, cursorPosition).split('\n').length - 1;
            if (lineIndex > 0) {
              const linesArray = newValue.split('\n');
              linesArray.splice(lineIndex, 1);
              newValue = linesArray.join('\n');
            }
          } else if (newValue[cursorPosition - 1] === bullet && (cursorPosition === newValue.length || newValue[cursorPosition] === '\n')) {
            newValue = newValue.slice(0, cursorPosition - 2) + newValue.slice(cursorPosition);
          }
        }
      
        event.target.value = newValue;
      
        this.setState({
          previousLength: newValue.length,
        });
      }

  render() {

    const { visualisationdetails, loading} = this.props;
    let visualdetails=visualisationdetails.visualimpression;
    let shoulderimpress='';
    let latmuscleimpress='';
    let spineimpress='';
    let hiprightimpress='';
    let hipleftimpress='';
    let hamrightimpress='';
    let gulterightimpress='';
    let balanceimpress='';
    let postureimpress='';
    if(visualdetails.length!=0){
        shoulderimpress= visualdetails[0].shoulder_impression; 
        latmuscleimpress=visualdetails[0].latmuscle_impression; 
        spineimpress=visualdetails[0].spine_impression; 
        hiprightimpress=visualdetails[0].hipright_impression; 
        hipleftimpress=visualdetails[0].hipleft_impression; 
        hamrightimpress=visualdetails[0].hamright_impression; 
        gulterightimpress=visualdetails[0].gulteright_impression; 
        balanceimpress=visualdetails[0].balance_impression; 
        postureimpress=visualdetails[0].posture_impression; 
        
    }

    const styles = {
        mainheading: {
            fontWeight:"bold",
            marginBottom:"50px",
            color:"#000",
            marginTop:"50px"
        },
        subheading: {
            fontWeight:"bold",
            marginTop:"80px", 
            marginBottom:"50px",
            color:"#000"
        },
        goals:{
            marginTop:"30px",
            marginBottom:"20px",
            color:"#000"
        },
        goalhead:{
          fontWeight:"bold",
          color:"#000"
        },
        textfield: {
            marginTop:"50px"
        },
        eachchart:{
           padding:"10px",
           position:"relative",
           zIndex:"1"
        },
        texare:{
            color:"#000",
            backgroundColor:"unset"
        },
        rctcontent:{
            marginTop:"80px",
            borderRadius: "5px",
            boxShadow: "0 1px 15px 1px rgba(69, 65, 78, 0.08)",
            border: "none",
            transition: "all 0.4s ease-in-out 0s",
            marginBottom: "50px",
            padding:"20px 0px 10px 0px",
            zIndex:"1"
        }
    };


    const studentName = this.props.data.studentName || '';
    const pdfFileName = `${studentName} - MSK Visualisation`;

    return (
        <div>
        <RctCollapsibleCard fullBlock >
            <div className="bjjt">
            <input type="button" className="mr-3 mb-3 btn btn-outline-warning float-right" onClick={this.props.onClick} value="Back" />
            </div>
            <form autoComplete="off" id="visualisationform" onSubmit={(e)=>this.addHandleSubmit(e)}>  
                    <PDFExport 
                            pageTemplate={PageTemplate}                    
                            scale={0.6}
                            paperSize="A4"
                            margin={{ top: "2.2cm", left: "1cm", right: "1cm", bottom: "1cm" }} 
                            fileName={pdfFileName}
                            ref={this.selectorRef}
                            forcePageBreak=".page-break" 
                            title=""
                            subject=""
                            keywords=""
                            author=""
                            producer=""
                            creator=""
                            pdfStyleSheet='./pdfstyles.css'
                            >    
                    <div style={styles.rctcontent}>
                        
                        <div className="rwhead">
                            <h2 className="text-center" style={styles.mainheading}>COMPARATIVE ANALYSIS OF MSK SCREENING </h2>
                        </div>
                        
                        <h3 className="text-center" style={styles.subheading}>Shoulder Mobility</h3>                        
                        <div style={styles.eachchart}>                            
                            <ShoulderElement data={850}/> 
                            <div className="rwhead" style={styles.goals}>
                                <h3 style={styles.goalhead}>Goals:</h3>
                                <p>Internal Rotation: 90 Degree</p>  
                                <p>External Rotation: 90 Degree</p>  
                            </div>
                            <div className="rwhead" style={styles.textfield}>
                                <h3 style={styles.goalhead}>Impression :</h3>
                                <textarea rows="4" type="text" style={styles.texare} name="shoulder_impression" id="shoulder_impression" defaultValue={shoulderimpress} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                            </div>
                        </div>
                        
                        <div className="page-break"></div>
                        <h3 className="text-center" style={styles.subheading}>Lats Muscle Length and Combined Elevation Test</h3>
                        <div style={styles.eachchart}> 
                            <LatmuscleElement data={850}/>
                            <div className="rwhead" style={styles.goals}>
                                <h3 style={styles.goalhead}>Goals :</h3>
                                <p>Lats Muscle Length: ≥ 170 Degree</p>  
                                <p>Combined Elevation Test: ≥ 20 Cm</p>  
                            </div>
                            <div className="rwhead" style={styles.textfield}>
                                <h3 style={styles.goalhead}>Impression :</h3>
                                <textarea rows="4" type="text" style={styles.texare} name="latmuscle_impression" id="latmuscle_impression" defaultValue={latmuscleimpress} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                            </div>
                        </div>    

                        <div className="page-break"></div>
                        <h3 className="text-center" style={styles.subheading}>Spine Mobility</h3>
                        <div style={styles.eachchart}> 
                            <SpineElement data={850}/>
                            <div className="rwhead" style={styles.goals}>
                                <h3 style={styles.goalhead}>Goals :</h3>
                                <p>Trunk Forward Flexion: ≥5cm</p>  
                                <p>Trunk Extension: ≥3cm</p>  
                                <p>Trunk Side Flexion: ≤3cm</p>  
                            </div>
                            <div className="rwhead" style={styles.textfield}>
                                <h3 style={styles.goalhead}>Impression :</h3>
                                <textarea rows="4" type="text" style={styles.texare} name="spine_impression" id="spine_impression" defaultValue={spineimpress} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                            </div>
                        </div>    

                        <div className="page-break"></div>
                        <h3 className="text-center" style={styles.subheading}>Hip Complex Mobility 1</h3>
                        <div style={styles.eachchart}>
                                <HiprightElement data={850}/> 
                            <div className="rwhead" style={styles.goals}>
                                <h3 style={styles.goalhead}>Goals :</h3>
                                <p>Iliopsoas Muscle: ≤5 degree</p>  
                                <p>Piriformis Muscle Length: ≤10 degree</p>  
                            </div>
                            <div className="rwhead" style={styles.textfield}>
                                <h3 style={styles.goalhead}>Impression :</h3>
                                <textarea rows="4" type="text" style={styles.texare} name="hipright_impression" id="hipright_impression" defaultValue={hiprightimpress} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                            </div>
                        </div>  

                        <div className="page-break"></div>  
                        <h3 className="text-center" style={styles.subheading}>Hip Complex Mobility 2</h3>
                            <div style={styles.eachchart}>
                                <HipleftElement data={850}/>
                            <div className="rwhead" style={styles.goals}>
                                <h3 style={styles.goalhead}>Goals :</h3>                        
                                <p>Hip Internal Rotation: ≥30 degree</p>
                                <p>Hip External Rotation: ≥45 degree</p>  
                            </div>
                            <div className="rwhead" style={styles.textfield}>
                                <h3 style={styles.goalhead}>Impression :</h3>
                                <textarea rows="4" type="text" style={styles.texare} name="hipleft_impression" id="hipleft_impression" defaultValue={hipleftimpress} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                            </div>
                        </div> 

                        <div className="page-break"></div>   
                        <h3 className="text-center" style={styles.subheading}>Hamstring and Quadriceps Muscle Length</h3>
                        <div style={styles.eachchart}>
                            <HamstringrightElement data={850}/>
                            <div className="rwhead" style={styles.goals}>
                                <h3 style={styles.goalhead}>Goals :</h3>
                                <p>Hamstring Muscle length: ≥160 degree</p>  
                                <p>Quadriceps Muscle length: ≥ 80 degree</p> 
                            </div>
                            <div className="rwhead" style={styles.textfield}>
                                <h3 style={styles.goalhead}>Impression :</h3>
                                <textarea rows="4" type="text" style={styles.texare} name="hamright_impression" id="hamright_impression" defaultValue={hamrightimpress} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                            </div>
                        </div>    

                        <div className="page-break"></div>
                        <h3 className="text-center" style={styles.subheading}>Glute Stability and TA Stability</h3>
                        <div style={styles.eachchart}>
                            <GulterightElement data={850}/>
                        </div>
                        <div className="rwhead" style={styles.goals}>
                            <h3 style={styles.goalhead}>Goals :</h3>
                            <p>Glute Endurance and Stability: Level 3 (≥90 sec)</p>  
                            <p>TA Control in Supine Position: Level 5</p> 
                        </div>
                        <div className="rwhead" style={styles.textfield}>
                            <h3 style={styles.goalhead}>Impression :</h3>
                            <textarea rows="4" type="text" style={styles.texare} name="gulteright_impression" id="gulteright_impression" defaultValue={gulterightimpress} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                        </div>  
                        
                        <div className="page-break"></div>
                        <h3 className="text-center" style={styles.subheading}>Balance and Proprioception</h3>
                        <div style={styles.eachchart}>
                            <BalanceElement data={850}/>
                            <div className="rwhead" style={styles.goals}>
                                <h3 style={styles.goalhead}>Goals :</h3>
                                <p>Eyes Open: {'>'}60 sec</p>  
                                <p>Eye Closed: {'>'}60 sec</p> 
                            </div>
                            <div className="rwhead" style={styles.textfield}>
                                <h3 style={styles.goalhead}>Impression :</h3>
                                <textarea rows="4" type="text"  style={styles.texare} name="balance_impression" id="balance_impression" defaultValue={balanceimpress} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                            </div>
                        </div>  

                        <div className="page-break"></div>  
                        <h3 className="text-center" style={styles.subheading}>Posture Analysis</h3>
                        <div style={styles.eachchart}>
                            <PostureElement />
                            <div className="rwhead" style={styles.textfield}>
                                <h3 style={styles.goalhead}>Impression :</h3>
                                <textarea rows="4" type="text" style={styles.texare} name="posture_impression" id="posture_impression" defaultValue={postureimpress} className="form-control form-control-alternative" onChange={evt => this.handleInput(evt)}></textarea>
                            </div>
                        </div>    
                    </div>  
                    </PDFExport>
                <div className="rwhead">
                    <input type="submit" className="mr-3 mb-3 btn btn-outline-primary" value="Submit" />
                    <button type="button" className="mr-3 mb-3 btn btn-outline-success" onClick={this.exportPDFWithMethod}>Export PDF</button>
                    <input type="button" className="mr-3 mb-3 btn btn-outline-warning" onClick={this.props.onClick} value="Back" />
                </div>
            </form>
        </RctCollapsibleCard> 
       </div>
    );
  }
}

const mapStateToProps = ({ mskvisualisation }) => {
  const { visualisationdetails, loading } = mskvisualisation;
return { visualisationdetails, loading };
}

export default connect(mapStateToProps, {
  mskVisualisationDetails,
  creatmskVisualisation
})(createvisual); 